export default {"src":"/_next/static/media/newIn.37dca28c.svg","height":4,"width":4,"blurWidth":0,"blurHeight":0};